import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuditComponent } from './audit.component';
import { MatInputModule, MatIconModule, MatButtonModule } from '@angular/material';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatButtonModule
    ],
    entryComponents: [],
    exports: [
        AuditComponent
    ],
    declarations: [
        AuditComponent
    ],
    providers: [],
    bootstrap: []
})
export class AuditModule {
}